import http from "./base";

class BathroomService{
    constructor(){}

    async saveNewBathroom(bathroomItem) {
        const url = `bathrooms`;
        var response = "";
        await http
            .post(url, bathroomItem,{
                headers: {
                    authorization: 'Bearer ' + sessionStorage.getItem('token')
                  },
            })
            .then(responseData => {
                response = responseData.data.data;
            })
            .catch(error => {
                response = error.response;
                throw new Error(`HTTP error! status: ${response.status}`);
            });

        return response;
    }

    async updateBathroomByID(id,body) {
        const url = `bathrooms/`+id;
        var response = "";
        await http
            .patch(url,body,{
                headers: {
                    authorization: 'Bearer ' + sessionStorage.getItem('token')
                  },
            })
            .then(responseData => {
                response = responseData.data.data;
            })
            .catch(error => {
                response = error.response;
                throw new Error(`HTTP error! status: ${response.status}`);
            });

        return response;
    }

    async deleteBathroomID(id) {
        const url = `bathrooms/`+id;
        var response = "";
        await http
            .delete(url,{
                headers: {
                    authorization: 'Bearer ' + sessionStorage.getItem('token')
                  },
            })
            .then(responseData => {
                response = responseData.data.data;
            })
            .catch(error => {
                response = error.response;
                throw new Error(`HTTP error! status: ${response.status}`);
            });

        return response;
    }


    async getAllBathrooms(venueID)  {
        const url = `bathrooms/getAll/`+venueID;

        var response = "";
        await http
            .get(url, {
                cache: false
            })
            .then(responseData => {
                response = responseData.data.data;
            })
            .catch(error => {
                response = error.response;
                throw new Error(`HTTP error! status: ${response.status}`);
            });

        return response;
    }



}

let service = new BathroomService();
export default service;



